import React from "react";
import EmailThreadList from "../../../components/email/EmailThreadList";
import {
  useAllNonActionableThreadsQuery,
  useUpdateStarredMutation,
  useUpdateNonActionableMutation,
  useUpdateActionableMutation,
} from "../../../Services/email/EmailInbox";
import NonActionableFilterModal from "../../../components/email/NonActionableFilterModal";

const NonActionable = () => {
  return (
    <EmailThreadList
      useThreadsQuery={useAllNonActionableThreadsQuery}
      useUpdateStarredMutation={useUpdateStarredMutation}
      useUpdateNonActionableMutation={useUpdateNonActionableMutation}
      useUpdateActionableMutation={useUpdateActionableMutation}
      FilterModalComponent={NonActionableFilterModal}
      filterSessionKey="selectNonActionableFilterAndValue"
      sessionKeyPrefix="nonActionableInitial_"
      title="Non-Actionable"
      filterKey="selectNonActionableFilterAndValue1"
    />
  );
};
export default NonActionable;
